import React, { useCallback, useContext, useEffect, useState } from "react";
import { CloseCircleOutlined, InboxOutlined } from "@ant-design/icons";
import { Alert, Card, Image, Space, Typography, Upload } from "antd";
import { useAuthenticatedFetch } from "@/Api/Axios";
import { getValueFromNestedObject } from "@/Utils/Index";
import { ulpoadImage } from "@/Utils/Utils";
import { UserContext } from "../../Context/UserContext";

export default function ImagePicker(props) {
  const fetch = useAuthenticatedFetch();
  const {
    form: { values, setFieldValue, errors, validateForm },
    field: { name, label },
  } = props;
  const { type, ...restFieldProps } = props.field;
  const value = getValueFromNestedObject(values, name);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const { userProfileData } = useContext(UserContext);

  useEffect(() => {
    fetchData();
  }, [userProfileData]);

  const fetchData = useCallback(async () => {
    const res = await fetch.get(`/organizations`);
    let currentOrganization = res.data.find((org) => org._id === userProfileData.currentOrganization.orgId);
    const url = currentOrganization?.assessmentPreview?.logo?.url;
    if (url) {
      currentOrganization.assessmentPreview.logo.url = url;
    }
    if (currentOrganization?.assessmentPreview?.logo) {
      setFiles([
        {
          url: currentOrganization.assessmentPreview.logo.url,
        },
      ]);
      setFieldValue(name, currentOrganization.assessmentPreview.logo);
      validateForm(values);
    }
  }, []);

  useEffect(() => {
    if (!props.field.allowMultiple) {
      if (files.length > 0) {
        setFieldValue(name, files[0]);
      } else {
        setFieldValue(name, files);
      }
    } else {
      setFieldValue(name, files);
    }

    validateForm(values);
  }, [files]);

  const handleDrop = useCallback(
    async (_dropFiles, acceptedFiles, _rejectedFiles) => {
      setLoading(true);
      const formData = new FormData();
      let fileValue;

      acceptedFiles.forEach((value) => {
        fileValue = value;
        formData.append("files", value, `${value.lastModified}.png`);
      });
      const uploadedVideo = await ulpoadImage(fetch, fileValue);
      const imageUrl = `${process.env.STORAGE_BASE_URL}/${uploadedVideo?.filename}`;
      setFiles([
        {
          url: imageUrl,
        },
      ]);
      setLoading(false);
    },
    [files]
  );

  const handleRemoveFile = async (file, index) => {
    //Remove file from shopify
    // console.log("Removing file :", file);
    const removeImage = await fetch.post("/remove-image", file, {
      "Content-Type": " multipart/form-data",
    });

    //Remove file from state
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  return (
    <Space direction="vertical" size="small" style={{ width: "100%" }}>
      <Typography.Text>{label}</Typography.Text>
      <Space size="large" align="center" wrap>
        {files.map((file, index) => (
          <Card key={index} style={{ padding: "8px", position: "relative" }} bodyStyle={{ padding: "8px" }}>
            <div className="file-upload-preview">
              <div
                className="remove-image"
                onClick={() => handleRemoveFile(file, index)}
                style={{
                  position: "absolute",
                  top: "4px",
                  right: "4px",
                  cursor: "pointer",
                  zIndex: 1,
                }}
              >
                <CloseCircleOutlined style={{ color: "#ff4d4f", fontSize: "16px" }} />
              </div>
              <Image width={64} height={64} src={file.url} alt="uploaded" style={{ objectFit: "cover" }} />
            </div>
          </Card>
        ))}
        {props.field.allowMultiple ? (
          <Upload.Dragger
            {...restFieldProps}
            accept={restFieldProps.fileType}
            customRequest={({ file, onSuccess }) => {
              handleDrop([], [file], []);
              onSuccess();
            }}
            showUploadList={false}
            style={{ width: "120px", height: "80px" }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Upload</p>
          </Upload.Dragger>
        ) : (
          files.length === 0 && (
            <Upload.Dragger
              {...restFieldProps}
              accept={restFieldProps.fileType}
              customRequest={({ file, onSuccess }) => {
                handleDrop([], [file], []);
                onSuccess();
              }}
              showUploadList={false}
              style={{ width: "120px", height: "80px" }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Upload</p>
            </Upload.Dragger>
          )
        )}
      </Space>
      {errors[name] && <Alert message={errors[name]} type="error" showIcon style={{ fontSize: "12px" }} />}
      {props.helpText && props.helpText.length > 0 && (
        <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
          {props.helpText}
        </Typography.Text>
      )}
    </Space>
  );
}
